import store from '@/store';
import { Module, VuexModule, Mutation, getModule } from 'vuex-module-decorators';

export interface ConstructionState {
  /** 検索条件 */
  searchConditions: Array<{ [key: string]: string | string[] }>;
}

/**
 * 工事案件管理関連の状態管理クラス
 * このクラスの状態はリロードすると状態がリセットされる
 */
@Module({
  name: 'construction',
  namespaced: true,
  dynamic: true,
  store
})
export class Construction extends VuexModule implements ConstructionState {
  searchConditions: Array<{ [key: string]: string | string[] }> = [];

  /**
   * 検索条件を保持する
   * @param condition 検索条件
   */
  @Mutation
  setSearchConditions(conditions: Array<{ [key: string]: string | string[] }>) {
    this.searchConditions = conditions;
  }

  /**
   * 保持している検索条件を消去する
   */
  @Mutation
  clearSearchConditions() {
    this.searchConditions = [];
  }
}

export default getModule(Construction);
